import {getStepFromPosition} from './getStepFromPosition.js';
import {getTotalLength} from "components/arrangement/getTotalLength.js";
import {
    setTotalArrangementLength
} from 'actions/index.js';
import SequenceRollEvent from 'session/SequenceRollEvent.js';
import PatternSwitchEvent from 'session/PatternSwitchEvent.js';
import {insertRollEvent} from 'session/operations/actions.js';
import {insertEvent} from 'session/operations/actions.js';
import {NO_SUB_SEQUENCE} from 'session/constants.js';
import {setSelectedArrangementEvents} from 'actions/index.js';

const DEFAULT_ROLL_DURATION = 8;
const DEFAULT_PATTERN_DURATION = 32;

export function getCursorStep(store) {
    let state = store.getState();
    return state.arrangement.cursorStep;
}

export function insertPatternEventAtCursor(mix, store) {
    let resolution = store.getState().sequencer.displayResolution;
    let cursorStep = getCursorStep(store);
    let event = new PatternSwitchEvent(0);
    event.step = cursorStep;
    mix.dispatch(insertEvent(event, DEFAULT_PATTERN_DURATION));
    store.dispatch(setSelectedArrangementEvents([event]));

    // update the total length in redux for the arr. view
    mix.sequencerEngine.dispatch(
        setTotalArrangementLength(getTotalLength(mix.sequencerEngine)));
}

export function insertRollEventAtCursor(mix, store) {
    let state = store.getState();
    let resolution = state.sequencer.displayResolution;
    let cursorStep = getCursorStep(store);
    let eventOn = new SequenceRollEvent(true, resolution);
    eventOn.step = cursorStep;

    let dur = 64;
    let xScale = state.arrangement.xScale;
    if (xScale < 0.8) {
        dur *= 2;
    } else if (xScale < 0.4) {
        dur *= 4;
    }
    mix.dispatch(insertRollEvent(eventOn, dur / resolution.resolution));
    store.dispatch(setSelectedArrangementEvents([eventOn.initialSubEvent]));
}
